export default "__VITE_ASSET__BJdDH5DL__"